import React, { useState } from 'react';
import { Radio, FormControlLabel, Grid } from '@mui/material';
import { HelpIcon } from 'shared/components';
import styled from 'styled-components';
import CustomTemplatePopup from './CustomTemplatePopup';
import { getDefaultTemplate, getDefaultSubject } from './default';

export default function EmailTemplate({
  form,
  ruleTriggerOptions,
  handleUpdate,
}) {
  const { values, setFieldValue } = form;
  const [popupIsOpen, setPopupIsOpen] = useState(false);

  const customStatusRule =
    form?.values?.ruleTriggerOptions &&
    form?.values?.ruleTriggerOptions.length === 1
      ? ruleTriggerOptions
          ?.filter(opt => opt.id === form?.values?.ruleTriggerOptions[0])?.[0]
          ?.name?.toUpperCase()
      : undefined;

  const handleChangeMode = (field, checked) => {
    const otherField =
      field === 'defaultTemplate' ? 'customTemplate' : 'defaultTemplate';
    const isCustom = otherField === 'defaultTemplate';
    if (isCustom) {
      setCustomInitial();
    } else {
      setFieldValue('notificationSubject', undefined);
      setFieldValue('notificationBody', undefined);
    }
    setFieldValue(field, checked);
    setFieldValue(otherField, false);
  };

  const handleOpenPopup = () => setPopupIsOpen(!popupIsOpen);

  const handleDone = (subject, body) => {
    setPopupIsOpen(false);
    setFieldValue('notificationSubject', subject);
    setFieldValue('notificationBody', body);
  };

  const setCustomInitial = () => {
    if (!values?.notificationBody && !values?.notificationSubject) {
      const initialBody = getDefaultTemplate(
        values.ruleTrigger,
        customStatusRule,
      );
      const initialSubject = getDefaultSubject(
        values.ruleTrigger,
        customStatusRule,
      );
      setFieldValue('notificationSubject', initialSubject);
      setFieldValue('notificationBody', initialBody);
    }
  };

  return (
    <Grid container direction="row" justify="center" alignItems="center">
      <Grid item xs={12}>
        <p>Email template:</p>
        <FormControlLabel
          style={{ marginRight: '0px' }}
          control={
            <Radio
              checked={values.defaultTemplate}
              onChange={e =>
                handleChangeMode('defaultTemplate', e.target.checked)
              }
              color="primary"
            />
          }
          label={'Rule default'}
        />
        <HelpIcon text="Uses the dafault template for the selected rule" />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          disabled={false}
          style={{ marginRight: '0px' }}
          control={
            <Radio
              checked={values.customTemplate}
              onChange={e =>
                handleChangeMode('customTemplate', e.target.checked)
              }
              color="primary"
            />
          }
          label={'Custom'}
        />
        <HelpIcon text="Allows you to customize the template and specify the title, body text and variables included" />
        {values.customTemplate && (
          <Link onClick={handleOpenPopup}>View/Edit template</Link>
        )}
      </Grid>
      <CustomTemplatePopup
        open={popupIsOpen}
        onClose={handleOpenPopup}
        onDone={handleDone}
        values={values}
        rule={values.ruleTrigger}
        customStatusRule={customStatusRule}
        handleUpdate={handleUpdate}
      />
    </Grid>
  );
}

const Link = styled.span`
  font-size: 16px !important;
  font-weight: 400 !important;
  color: #0072a2 !important;
  text-decoration: underline;
  cursor: pointer;
`;
